import { EURO, LimitStepEnum, PREFIX_HANDLE, UNDERSCORE, bikeLabelStep } from "./constants"
import { BikeLabelOrderIndexStepEnum, StepHandlers } from "./types"

export const numberBigToString = (value) => {
	return JSON.stringify(value).toString()
}

export const splitString = (chain: string) => {
	const delimiters = / et|,/
	return chain.split(delimiters)
}

export const isLastElementInMap = (key: number, mapList: Array<any>) => {
	return key === mapList?.length - 1
}

export const PriceEuroNumber = (chain: string | number) => {
	return `${chain} ${EURO}`
}

export const IsBikeLabelOrderStep = (chain: string): boolean => {
	return Number(chain) > 0 && Number(chain) <= LimitStepEnum.MAX_LIMIT_STEP
}

export const getStep = (step: `${BikeLabelOrderIndexStepEnum}`) => {
	if (IsBikeLabelOrderStep(step))
		return Object.entries(bikeLabelStep).find(([_, { index }]) => index === step)[1]
	return null
}

export const SnakeCaseToCamelCase = (chain: string) => {
	return chain
		.split(UNDERSCORE)
		.map((word: string) => `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`)
		.join("")
}

export const handlerGenerateByEnumeration = <T extends Record<string, any>>(
	enumeration: T,
	callBack: (val: string) => void
) =>
	Object.fromEntries(
		Object.entries(enumeration).map(([key, value]) => [
			`${PREFIX_HANDLE}${SnakeCaseToCamelCase(key)}`,
			() => callBack(value),
		])
	) as StepHandlers<T>
